import { DndContext, DragEndEvent } from "@dnd-kit/core";
import { SortableContext, useSortable } from "@dnd-kit/sortable";
import {
  Box,
  Button,
  Flex,
  Group,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { IconGripVertical, IconPlus, IconTrash } from "@tabler/icons-react";
import React from "react";
import { tblComboSetGroupModels } from "../../model/Comboset";
import ItemProduct from "./ItemProduct";

type Props = {
  indexGroup: number;
  products: any[];
  hasMoreThan6: boolean;
  openedProductLists: Record<number, boolean>;
  toggleProductCollapse: (indexGroup: number) => void;
  dataGroupItem: tblComboSetGroupModels[] | [];
  setDataGroupItem: React.Dispatch<
    React.SetStateAction<tblComboSetGroupModels[]>
  >;
  handleChangeNameComboSet: (value: string, indexGroup: number) => void;
  openModal: (type: number, indexGroup: number) => void;
  handleUpdateSortOrder: (indexGroup: number, value: number | string) => void;
  handleRemoveGroup: (indexGroup: number) => void;
};
const SortableGroupItem = ({
  indexGroup,
  products,
  hasMoreThan6,
  openedProductLists,
  toggleProductCollapse,
  dataGroupItem,
  setDataGroupItem,
  handleChangeNameComboSet,
  openModal,
  handleUpdateSortOrder,
  handleRemoveGroup,
}: Props) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: dataGroupItem[indexGroup].id ?? `group-${indexGroup}`,
    });

  // Hàm xử lý kéo thả sản phẩm trong nhóm
  // Hàm xử lý kéo thả sản phẩm trong nhóm
  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    // Nếu không có vị trí mới hoặc kéo thả vào chính nó thì không làm gì
    if (!over || active.id === over.id) return;

    setDataGroupItem((prev) => {
      // Tạo bản sao mảng nhóm sản phẩm
      const newGroups = [...prev];
      // Lấy danh sách sản phẩm của nhóm hiện tại
      const products = [
        ...(newGroups[indexGroup].tblComboSetProdCommands || []),
      ];
      // Tìm vị trí cũ của sản phẩm bị kéo (dựa vào id)
      const oldIndex = products.findIndex(
        (p, idx) => String(p.itemId ?? `product-${idx}`) === String(active.id)
      );
      // Tìm vị trí mới (nơi thả sản phẩm)
      const newIndex = products.findIndex(
        (p, idx) => String(p.itemId ?? `product-${idx}`) === String(over.id)
      );
      // Nếu không tìm thấy vị trí thì trả về mảng cũ
      if (oldIndex === -1 || newIndex === -1) return prev;

      // Lấy sản phẩm bị kéo ra khỏi vị trí cũ
      const [moved] = products.splice(oldIndex, 1);
      // Chèn sản phẩm vào vị trí mới
      products.splice(newIndex, 0, moved);

      // Cập nhật lại sortOrder cho từng sản phẩm theo thứ tự mới
      products.forEach((item, idx) => {
        item.sortOrder = idx + 1;
      });

      // Gán lại danh sách sản phẩm đã sắp xếp cho nhóm hiện tại
      newGroups[indexGroup] = {
        ...newGroups[indexGroup],
        tblComboSetProdCommands: products,
      };
      // Trả về mảng nhóm đã cập nhật
      return newGroups;
    });
  };
  return (
    <Box
      ref={setNodeRef}
      {...attributes}
      style={{
        transform: transform
          ? `translate(${transform.x}px, ${transform.y}px)`
          : undefined,
        transition,
        border: "1px solid #008000",
        borderRadius: 8,
        padding: 12,
        marginTop: 32,
      }}
    >
      <Group>
        <Flex
          w={"100%"}
          direction={"row"}
          align="center"
          justify="space-between"
        >
          <Flex direction={"row"} align="center" gap={8} w={"60%"}>
            <Text fw={500} mb={10}>
              Nhóm {indexGroup + 1}
            </Text>
            <TextInput
              type="text"
              placeholder="Nhập tên nhóm sản phẩm"
              value={dataGroupItem?.[indexGroup]?.groupName}
              onChange={(e) =>
                handleChangeNameComboSet(e.target.value, indexGroup)
              }
              size="md"
              style={{ width: "80%" }}
            />
          </Flex>

          <Flex direction={"row"} align="center" gap={8}>
            <Group gap="sm">
              <Tooltip label="Thêm sản phẩm">
                <Button
                  type="button"
                  leftSection={<IconPlus />}
                  onClick={() => {
                    console.log("Open modal to add product", indexGroup);
                    openModal(0, indexGroup);
                  }}
                >
                  Thêm
                </Button>
              </Tooltip>
              <Tooltip label="Xóa sản phẩm">
                <Button
                  variant="outline"
                  type="button"
                  color="red"
                  leftSection={<IconTrash size={20} />}
                  onClick={() => handleRemoveGroup(indexGroup)}
                />
              </Tooltip>
            </Group>
            {/* Icon kéo thả, chỉ truyền listeners vào đây */}
            <span {...listeners} style={{ cursor: "grab", marginRight: 8 }}>
              <IconGripVertical size={18} />
            </span>
          </Flex>
        </Flex>
      </Group>
      <Box>
        <DndContext onDragEnd={handleDragEnd}>
          <SortableContext
            items={products.map((product, idx) =>
              String(product.itemId ?? `product-${idx}`)
            )}
          >
            {products.map((product, indexItem) => (
              <ItemProduct
                key={String(product.itemId ?? `product-${indexItem}`)}
                itemIndex={indexItem}
                indexItem={indexItem}
                indexGroup={indexGroup}
                dataGroupItem={dataGroupItem}
                setDataGroupItem={setDataGroupItem}
              />
            ))}
          </SortableContext>
        </DndContext>
      </Box>
    </Box>
  );
};

export default SortableGroupItem;
